import { GapData, GapItem } from '../types/scorecard';

export const initialGapData: GapItem[] = [
 {
  "id": "gap-001",
  "title": "No FDA Clearance ",
  "description": "The 510(k) for Low EF detection/ SHD 510(k) targets Month 12 submission (Dec 2026) with expected clearance Jan 2027. ",
  "severity": "Critical",
  "timeline": "12-16 months",
  "status": "In Progress",
  "recommendation": "Accelerate FDA Pre-Sub to Month 3–4 (May–Jun 2026) rather than Month 5. Engage JREG immediately to begin submission drafting in parallel with ISO 13485 audits.",
  "lastUpdated": new Date("2026-02-28T14:38:16.200Z"),
  "categories": [
   "Regulatory"
  ]
 },
 {
  "id": "gap-002",
  "title": "BIDMC dataset exclusivity and hospital incentivisation",
  "description": "Negotiate dataset exclusivity and hospital to trail and help open US doors\n",
  "severity": "Critical",
  "timeline": "Immediate",
  "status": "Not Started",
  "recommendation": "Speak with D and J asap",
  "lastUpdated": new Date("2026-02-28T14:32:23.238Z"),
  "categories": [
   "IP"
  ]
 },
 {
  "id": "gap-003",
  "title": "No US Legal Entity or Commercial Presence",
  "description": "Cardiovolt.ai Ltd is a UK company (No. 165031061, registered at Paul Street, London). To sell to US hospitals, bill Medicare, or contract with US CROs/pharma, a US subsidiary (C-Corp or LLC) is required.",
  "severity": "Low",
  "timeline": "4-6 weeks",
  "status": "Not Started",
  "recommendation": "Establish US Delaware C-Corp before Series A. Required for: (a) FDA registration as device establishment, (b) Medicare/CMS billing, (c) contracts with Optum/Medpace/HeartSciences.",
  "lastUpdated": new Date("2026-02-28T14:14:13.406Z"),
  "categories": [
   "Commercial"
  ]
 },
 {
  "id": "gap-004",
  "title": "No Production-Grade API or Certified Software Product",
  "description": "The Tech Stack document confirms AI models are complete but states \"our main goals over the next 6–12 months are software development to allow API access and usability testing.\" The entire B2B business model depends on API integration.",
  "severity": "Critical",
  "timeline": "6-10 months",
  "status": "In Progress",
  "recommendation": "Define MVP API specification immediately. Prioritise: (a) FHIR R4 compliant endpoints, (b) HL7 message handling, (c) DICOM ECG signal ingestion, (d) structured output (JSON risk scores + survival curves).",
  "lastUpdated": new Date("2026-02-28T13:54:41.528Z"),
  "categories": [
   "Operational"
  ]
 },
 {
  "id": "gap-005",
  "title": "All Channel Partnerships Are \"In Discussion\" — None Executed",
  "description": "Business Plan lists \"active partnership discussions\" with Optum, Medpace, HeartSciences/MyoVista, Medilynq, Terra API, and Philips. The data room contains a Medpace partnership proposal (not a signed agreement).",
  "severity": "High",
  "timeline": "3-6 months",
  "status": "In Progress",
  "recommendation": "Convert at least one partnership to a signed LOI or pilot agreement pre-Series A. Medpace CRO channel is highest priority (no FDA needed).",
  "lastUpdated": new Date("2026-02-28T13:54:41.528Z"),
  "categories": [
   "Commercial"
  ]
 },
 {
  "id": "gap-006",
  "title": "No Dedicated US Sales or Business Development Capability",
  "description": "The founding team is clinical-academic (CEO, CSO, CMO, CTO all UK-based). US hospital procurement requires persistent local relationships, knowledge of GPO dynamics, understanding of health system buying cycles (6–18 months).",
  "severity": "Critical",
  "timeline": "6 months",
  "status": "Not Started",
  "recommendation": "Hire US-based VP of Commercial or Head of US Market no later than Month 6. Ideal profile: 5–10 years medtech/SaMD sales, cardiology domain, EHR integration experience.",
  "lastUpdated": new Date("2026-02-28T14:14:40.434Z"),
  "categories": [
   "Commercial"
  ]
 },
 {
  "id": "gap-007",
  "title": "CRO Revenue Stream Underdeveloped Despite Being Fastest Path to Revenue",
  "description": "Clinical trial enrichment via CROs does NOT require FDA clearance — it's a research tool. Yet the Medpace relationship is still at proposal stage. The CRO market is ripe: 70%+ of CROs expected to deploy AI analytics by 2026.",
  "severity": "High",
  "timeline": "3-6 months",
  "status": "Not Started",
  "recommendation": "Package a CRO-specific offering immediately: (1) Define trial enrichment product (batch ECG analysis API), (2) Set pricing (per-ECG or per-trial-arm), (3) Propose Medpace paid pilot ($50–100K).",
  "lastUpdated": new Date("2026-02-28T13:54:41.528Z"),
  "categories": [
   "Commercial"
  ]
 },
 {
  "id": "gap-008",
  "title": "EHR Integration Architecture Not Defined for US Market",
  "description": "The US EHR market requires SMART on FHIR, FHIR R4 compliance, and specific integration patterns for Epic and Oracle Health. No EHR-specific integration architecture is documented.",
  "severity": "High",
  "timeline": "6-12 months",
  "status": "Not Started",
  "recommendation": "Define EHR integration architecture as part of software development scope. Priorities: (1) SMART on FHIR app for Epic, (2) CDS Hooks for real-time clinical decision support.",
  "lastUpdated": new Date("2026-02-28T14:35:28.555Z"),
  "categories": [
   "Operational",
   "Regulatory"
  ]
 },
 {
  "id": "gap-009",
  "title": "No Prospective Clinical Evidence or Real-World Data from US Sites",
  "description": "All prospective validation is UK-based (Chelsea & Westminster, Imperial NHS). US hospital and payer procurement strongly favours products with US clinical evidence.",
  "severity": "High",
  "timeline": "8-12 months",
  "status": "Not Started",
  "recommendation": "Leverage Kramer/Waks at BIDMC for US validation study (can run in parallel, no FDA needed). Target: submit results to leadingconference.",
  "lastUpdated": new Date("2026-02-28T14:38:58.018Z"),
  "categories": [
   "Regulatory",
   "Operational"
  ]
 },
 {
  "id": "gap-010",
  "title": "Pricing Strategy Not Market-Tested",
  "description": "Competition document proposes $128.90/analysis (CPT reimbursement) for US and ~£8+ for NHS. However, no pricing validation with potential customers. CRO pricing undefined.",
  "severity": "Medium",
  "timeline": "3-6 months",
  "status": "Not Started",
  "recommendation": "Build a health economics ROI calculator showing cost avoidance. Test pricing with Medpace (CRO) and HeartSciences (clinical). Commission HEOR analysis aligned with NICE/CMS requirements.",
  "lastUpdated": new Date("2026-02-28T13:54:41.528Z"),
  "categories": [
   "Commercial"
  ]
 },
 {
  "id": "gap-011",
  "title": "Cybersecurity and SOC 2 Certification Gap",
  "description": "US hospitals increasingly require SOC 2 Type II and HITRUST CSF for software vendors. IEC 81001-5-1 cybersecurity is referenced but SOC 2 and HITRUST are not mentioned.",
  "severity": "Medium",
  "timeline": "10-16 months",
  "status": "Not Started",
  "recommendation": "Plan SOC 2 Type I in parallel with ISO 13485 (overlapping controls). Target Type I by Month 10, Type II by Month 16. Budget: $30–60K.",
  "lastUpdated": new Date("2026-02-28T13:54:41.528Z"),
  "categories": [
   "Operational"
  ]
 },
 {
  "id": "gap-012",
  "title": "De Novo Timeline Understanding",
  "description": "The regulatory strategy positions De Novo multi-disease platform as the key moat. However, De Novo typically takes 6–12+ months of FDA review (only 3.2% of AI/ML devices use this pathway).",
  "severity": "Medium",
  "timeline": "12-24 months",
  "status": "Not Started",
  "recommendation": "Build De Novo buffer into financial projections (assume 12–18 months from submission to clearance). Consider Pre-De Novo meeting at Month 8.",
  "lastUpdated": new Date("2026-02-28T14:18:08.800Z"),
  "categories": [
   "Regulatory"
  ]
 },
 {
  "id": "gap-013",
  "title": "Brand/IP and Marketing Infrastructure Absent",
  "description": "Trademarks not registered. No US-targeted marketing website, product collateral, or conference presence strategy. Strong media coverage (Guardian, Telegraph) is UK-focused.",
  "severity": "High",
  "timeline": "6-12 months",
  "status": "Not Started",
  "recommendation": "Register trademarks (Cardiovolt, AIRE) in US and EU. Develop US-targeted website. Plan ACC 2027 (March) and AHA 2027 (November) presence aligning with post-510(k) launch.",
  "lastUpdated": new Date("2026-02-28T14:31:54.327Z"),
  "categories": [
   "Commercial",
   "IP"
  ]
 },
 {
  "id": "gap-014",
  "title": "Post-Market Surveillance System Not Built",
  "description": "EUMDR strategy describes PMCF and PSUR requirements. FDA requires post-market surveillance for AI/ML devices. No technical infrastructure for real-world performance monitoring.",
  "severity": "Low",
  "timeline": "12+ months",
  "status": "Not Started",
  "recommendation": "Include real-time performance monitoring in API architecture from v1.0. Track: prediction accuracy vs. outcomes, model drift metrics, demographic performance parity.",
  "lastUpdated": new Date("2026-02-28T14:32:09.126Z"),
  "categories": [
   "Operational",
   "Regulatory"
  ]
 }
];

export const defaultGapData: GapData = {
 gaps: initialGapData,
 lastModified: new Date()
};